import { AxiosInstance } from "../../../axios/axiosInstance"
import { apiRoutes } from "../../../utils/ApiRoutes"
import { IAddHeatmapData, IDeleteHistoryData, IEditHeatmapData, IHeatmapReportData } from "../IApisInterface"

export const getHeatmapHistoryApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.heatmapHistory)
    return response
}

//new pagination
export const getHeatmapHistoryPaginationApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.heatmapHistoryPagination, payload)
    return response
}

//new heatmap keyword history for map
export const adminHeatmapKeywordHistoryApi = async (payload: { business_id: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.adminHeatmapKeywordHistory, payload)
    return response
}

//new heatmap keyword history for map
export const heatmapKeywordHistoryApi = async (payload: { business_id: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.heatmapKeywordHistory, payload)
    return response
}

export const pinHeatmapApi = async (payload: { heatmapId: string; pinned: boolean }) => {
    const response = await AxiosInstance.post(apiRoutes?.pinHeatmap, payload)
    return response
}

export const getAdminHeatmapHistoryApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.adminHeatmapHistory, payload)
    return response
}

export const getAdminHeatmapHistoryPaginationApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.adminHeatmapHistoryPagination, payload)
    return response
}

export const addHeatmapScanApi = async (payload: IAddHeatmapData) => {
    const response = await AxiosInstance.post(apiRoutes?.addHeatMapScan, payload)
    return response
}

export const deleteHeatmapApi = async (ids: string[]) => {
    const response = await AxiosInstance.post(apiRoutes?.deleteHeatmapHistory, ids)
    return response
}

export const heatmapReportApi = async (payload: IHeatmapReportData) => {
    const response = await AxiosInstance.post(apiRoutes?.reportHeatmap, payload)
    return response
}

export const getHeatmapApi = async (payload: { heatmapId: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.getHeatmap, payload)
    return response
}

export const getAdminHeatmapApi = async (payload: { heatmapId: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.getAdminHeatmap, payload)
    return response
}

export const deleteHistoryApi = async (payload: IDeleteHistoryData) => {
    const response = await AxiosInstance.post(apiRoutes?.deleteHistory, payload)
    return response
}

export const refreshReportApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.refreshReport, payload)
    return response
}

export const adminRefreshReportApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.adminRefreshReport, payload)
    return response
}

export const editHeatmapApi = async (payload: IEditHeatmapData) => {
    const response = await AxiosInstance.post(apiRoutes?.editHeatmap, payload)
    return response
}

export const getHeatmapGridApi = async (params: {
    lat: number | undefined;
    lng: number | undefined;
    radius: number;
    grid_multiplier: number;
}) => {
    const response = await AxiosInstance.get(apiRoutes?.heatmapGrid, { params })
    return response
}

export const togglePauseRefreshHeatmapApi = async (heatmapId: string) => {
    const response = await AxiosInstance.post(apiRoutes?.toggleHeatmap, { heatmapId })
    return response
}

export const adminTogglePauseRefreshHeatmapApi = async (heatmapId: string) => {
    const response = await AxiosInstance.post(apiRoutes?.adminToggleHeatmap, { heatmapId })
    return response
}

export const getAdminHeatmapGridApi = async (params: {
    lat: number | undefined;
    lng: number | undefined;
    radius: number;
    grid_multiplier: number;
}) => {
    try {
        const response = await AxiosInstance.get(apiRoutes?.getAdminHeatmapGrid, {
            params,
        })
        return response
    } catch (error) {
        console.error(error)
        return error
    }
};

export const heatmapComapreBusienssApi = async (payload: {
    reportId: string;
    competitorPlaceId: string;
    businessId: string;
}, signal?: AbortSignal) => {
    const response = await AxiosInstance.post(apiRoutes?.heatmapCompareBusiness, payload, { signal })
    return response
}

export const adminHeatmapComapreBusienssApi = async (payload: {
    reportId: string;
    competitorPlaceId: string;
    businessId: string;
}, signal?: AbortSignal) => {
    const response = await AxiosInstance.post(apiRoutes?.adminHeatmapCompareBusiness, payload, { signal })
    return response
}